/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_syllable_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Syllable Counter breaks down any text into syllables, words, and per-line counts as you type, and the built-in Haiku Checker validates the classic 5-7-5 pattern line by line.`)
};

const es_home_seo_syllable_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El Contador de sílabas desglosa cualquier texto en sílabas, palabras y recuentos por línea mientras escribes, y el Verificador de haiku integrado valida el clásico patrón 5-7-5 línea por línea.`)
};

const de_home_seo_syllable_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Silbenzähler schlüsselt jeden Text während des Tippens in Silben, Wörter und Zeilenzahlen auf, und der integrierte Haiku-Prüfer validiert das klassische 5-7-5-Muster Zeile für Zeile.`)
};

const nl_home_seo_syllable_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Lettergreepteller splitst elke tekst op in lettergrepen, woorden en telling per regel terwijl je typt, en de ingebouwde Haiku-controle valideert het klassieke 5-7-5-patroon regel voor regel.`)
};

const fr_home_seo_syllable_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le Compteur de syllabes décompose n'importe quel texte en syllabes, mots et comptages par ligne au fur et à mesure que vous tapez, et le Vérificateur de haïku intégré valide le schéma classique 5-7-5 vers par vers.`)
};

const it_home_seo_syllable_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il Contatore di Sillabe scompone qualsiasi testo in sillabe, parole e conteggi per riga mentre digiti, e il Verifica Haiku integrato convalida il classico schema 5-7-5 riga per riga.`)
};

const pt_br2_home_seo_syllable_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Contador de Sílabas decompõe qualquer texto em sílabas, palavras e contagens por linha enquanto você digita, e o Verificador de Haiku integrado valida o clássico padrão 5-7-5 linha por linha.`)
};

const pt_home_seo_syllable_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Contador de Sílabas decompõe qualquer texto em sílabas, palavras e contagens por linha à medida que escreve, e o Verificador de Haiku integrado valida o clássico padrão 5-7-5 linha a linha.`)
};

const ja_home_seo_syllable_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音節カウンターは、入力するたびにあらゆるテキストを音節数・単語数・行ごとの数値に分解し、内蔵の俳句チェッカーが伝統的な5-7-5パターンを行ごとに検証します。`)
};

const zh_home_seo_syllable_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音节计数器会在你输入时，将任意文本拆解为音节数、单词数和逐行统计数据，内置的俳句检测器还能逐行验证经典的5-7-5格式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_syllable_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_syllable_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_syllable_p1", locale)
	if (locale === "en") return en_home_seo_syllable_p1(inputs)
	if (locale === "es") return es_home_seo_syllable_p1(inputs)
	if (locale === "de") return de_home_seo_syllable_p1(inputs)
	if (locale === "nl") return nl_home_seo_syllable_p1(inputs)
	if (locale === "fr") return fr_home_seo_syllable_p1(inputs)
	if (locale === "it") return it_home_seo_syllable_p1(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_syllable_p1(inputs)
	if (locale === "pt") return pt_home_seo_syllable_p1(inputs)
	if (locale === "ja") return ja_home_seo_syllable_p1(inputs)
	return zh_home_seo_syllable_p1(inputs)
};